import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import styles from './../style/MoskitnieSistemySlyder2.module.scss'

import { Container, Image, Card } from 'react-bootstrap'
import ClientOnlyFsLightbox from './ClientOnlyFsLightbox'
import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'

class MoskitnieSistemySlyder2 extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.state = {
      activeIndex: 0,
      show_feedback: false,
      feedback_title: ``,
      lightboxController: {
        toggler: false,
        slide: 1
      }
    }
  }

  showFeedback = ( title ) => {
    this.setState({ show_feedback: true, feedback_title: title });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext()
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev()
    }
  }

  handleSlideChange = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.setState({
        activeIndex: this.swiperRef.current.swiper.realIndex
      })
    }
  }

  // Функция для открытия лайтбокса
  openLightbox = (index) => {
    this.setState({
      lightboxController: {
        toggler: !this.state.lightboxController.toggler,
        slide: index + 1
      }
    })
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {
    const { data } = this.props,
    { show_feedback, feedback_title, lightboxController } = this.state

    return (
      <section className={styles.section}>
        <Container>
          {/* Lightbox компонент */}
          <ClientOnlyFsLightbox
            toggler={lightboxController.toggler}
            sources={data?.list.map(item => item.full || item.image)}
            slide={lightboxController.slide}
          />

          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.rtext || ``}
            className={styles.title}
          />
          <div className={styles.text}>{data?.text}</div>
          <div className={styles.swiper_container}>
            <Swiper
              ref={this.swiperRef}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={2}
              loop={true}
              onSlideChange={this.handleSlideChange}
              onSwiper={(swiper) => {
                this.setState({ activeIndex: swiper.realIndex })
              }}
              breakpoints={{
                992: {
                  slidesPerView: 2
                },
                1202: {
                  slidesPerView: 2
                }
              }}
            >
              {data?.list.map((elm, index) => (
                <SwiperSlide key={index}>
                  <Card className={styles.card}>
                    <Card.Body className={styles.card_grid}>
                      <div>
                        <Card.Title className={styles.card_title}>
                          <div>{elm?.name}</div>
                          <div className={styles.card_title_num}>{this.formatSlideNumber(index)}</div>
                        </Card.Title>
                        <Card.Text className={styles.card_title2}>{elm?.title}</Card.Text>
                        <Card.Text>{elm?.text}</Card.Text>
                        <GreenButton
                          text={`Подробнее`}
                          width={247}
                          action={() => { this.showFeedback( `${elm?.title} ${elm?.name}` ) }}
                        />
                      </div>
                      {/* Добавляем обработчик клика для открытия изображения в лайтбоксе */}
                      <Image 
                        className={styles.card_img} 
                        src={elm?.image} 
                        alt={elm?.name} 
                        width={279} 
                        height={190}
                        onClick={() => this.openLightbox(index)}
                        style={{cursor: 'pointer'}}
                      />
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className={styles.slydenav_btns}>
              <div></div>
              <div className={styles.slydenav_btn} onClick={this.nextSlide}>
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                </svg>
              </div>
            </div>
          </div>
        </Container>
        <FeedbackForm
          title={feedback_title}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

MoskitnieSistemySlyder2.propTypes = {
  data: PropTypes.object
}

MoskitnieSistemySlyder2.defaultProps = {
  data: {}
}

export default MoskitnieSistemySlyder2